import styled from 'styled-components';

export type CompanyBannerProps = {
  url: string | null;
};

export const CompanyBanner = ({ url }: CompanyBannerProps) => {
  return <StyledBanner $url={url || ''} />;
};

const StyledBanner = styled.div<{ $url: string }>((p) => ({
  background: `url(${p.$url}) no-repeat`,
  width: '100%',
  height: 240,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  '@media (max-width: 600px)': {
    height: 160,
  },
}));
